// extracted by mini-css-extract-plugin
export default {"logo":"HeaderLogo_logo__Ps2cA"};